import _css from "@emotion/css";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import iconButtonStyle from "./IconButton.style";
import ButtonBase from "../ButtonBase/ButtonBase";

const IconButton = ({
  icon,
  disabled,
  loading,
  label,
  className,
  size,
  type,
  onClick,
  disableRipple,
  buttonAttributes
}) => {
  const Icon = icon;
  return ___EmotionJSX(ButtonBase, _extends({
    css:
    /*#__PURE__*/
    _css([iconButtonStyle.container.base, iconButtonStyle.container.bySize[size]], "label:IconButton;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    type: type,
    className: className,
    disabled: disabled,
    loading: loading,
    "aria-label": label,
    onClick: onClick,
    disableRipple: disableRipple
  }, buttonAttributes), loading ? ___EmotionJSX(CircularProgress, {
    color: "inherit",
    size: iconButtonStyle.loader.bySize[size]
  }) : ___EmotionJSX(Icon, {
    css: iconButtonStyle.content.bySize[size]
  }));
};

IconButton.defaultProps = {
  type: 'secondary',
  disabled: false,
  loading: false,
  className: undefined,
  size: 'medium',
  onClick: () => {},
  disableRipple: false,
  buttonAttributes: {}
};
IconButton.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'special', 'transparent', 'inherit']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['micro', 'xSmall', 'small', 'medium', 'large', 'xLarge']),
  onClick: PropTypes.func,
  disableRipple: PropTypes.bool,
  buttonAttributes: PropTypes.object
};
export default React.memo(IconButton);